import React, { useEffect } from 'react';

const Testimonials: React.FC = () => {

    return (
        <div className="card login-testimonial-sec invisible">
            <div className="card-body">
                <blockquote className="mb-0 text-center">
                    <div className="mb-3">
                        <img
                            className="rounded-circle user-img"
                            id="tetimonial_image_url"
                            src="https://d2p078bqz5urf7.cloudfront.net/images/login/placeholder.webp"
                            alt="Avatar Image"
                        />
                    </div>
                    <p className="blockquote-content" id="tetimonial_content"></p>
                    <div className="info">
                        <h5 className="mb-1" id="tetimonial_name"></h5>
                        <p className="mb-0" id="tetimonial_role"></p>
                    </div>
                </blockquote>
            </div>
        </div>
    );
};

export default Testimonials;